import math from '../../../../services/expression';
import { Store } from '../../../../redux/stores';
import { chatActions, rtcBufferActions } from '../../../../redux/actions/';
import { Message, ParseMessage, GenerateMessageId } from '../../../ChatBox/Message';
import { matchRecursive, resolveTreeExpressions, expandTreeExpressions } from '../../../../services/matchRecursive';


export const parseMacroAndSendToChat = (macro, sheet, callback) => {
    let parser = new MacroParser();

    parser.setSheet(sheet);
    parser.setMacro(macro);
    let result = parser.parse();

    const state = Store.getState();
    const email = state.authState.email;
    const user = state.authState.name;
    const color = state.authState.color;
    const groupId = GenerateMessageId();

    for (let line of result) {
        const {content, command} = ParseMessage(line, groupId);
        const msg = Message(email, user, color, command, content, groupId);

        Store.dispatch(chatActions.addMessage(msg));
        Store.dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'chatMessage',
            data: JSON.stringify(msg)
        }));

    }

    if (typeof callback === 'function') {
        callback();
    }
}

export const sendToChat = (title, description, callback) => {
    const state = Store.getState();
    const email = state.authState.email;
    const user = state.authState.name;
    const color = state.authState.color;
    const groupId = GenerateMessageId();

    const {content, command} = ParseMessage(`@rule ${title} | ${description}`, groupId);
    const msg = Message(email, user, color, command, content, groupId);

    Store.dispatch(chatActions.addMessage(msg));
    Store.dispatch(rtcBufferActions.pushOutputBuffer({
        type: 'chatMessage',
        data: JSON.stringify(msg)
    }));

    if (typeof callback === 'function') {
        callback();
    }
}

export const parseControlFunctions = (result) => {
    let prevent = 0;

    // Parse #IF(condition, true, false)#

    let regIf = /#if\(\s*(.*?)\s*,\s*(.*?)\s*,\s*(.*?)\s*\)if#/i;
    let ifParts = null;
    while((ifParts = regIf.exec(String(result))) && prevent++<1000){
        try {
            if (ifParts && 
                    typeof ifParts[1] !== 'undefined' && 
                    typeof ifParts[2] !== 'undefined' &&
                    typeof ifParts[3] !== 'undefined') {

                let conditionResult = math.evaluate(ifParts[1]);
                result = result.replace(ifParts[0], conditionResult ? ifParts[2] : ifParts[3]);
            } else {
                result = result.replace(ifParts[0], "");
                throw new Error('if statement misformatted');
            }
        } catch (e) {
            result = result.replace(ifParts[0], "");
            console.log(`Unable to evaluate ${ifParts[0]} statement`);
        }
    }

    //floor
    // Parse #INT(value)INT#
    let regInt = /#int\(\s*(.*?)\s*\)int#/gi;
    let intParts = null;
    while((intParts = regInt.exec(String(result))) && prevent++<1000){
        try {
            if (intParts && typeof intParts[1] !== 'undefined') {
                result = result.replace(intParts[0], `floor(${intParts[1]})`);
            } else {
                throw new Error('int statement misformatted');
            }
        } catch (e) {
            result = result.replace(intParts[0], "");
            console.log(`Unable to evaluate ${intParts[0]} statement`);
        }
    }

    return result;
}


export default class MacroParser {
    constructor() {
        this.commands = [];
        this.sheet = {};
        this.macro = '';
    }

    setSheet(sheet) {
        this.sheet = sheet;
    }

    setMacro(macro) {
        this.macro = macro;
    }

    parse(macro, sheet) {
        if (macro) {
            this.setMacro(macro);
        }

        if (sheet) {
            this.setSheet(sheet);
        }

        let result = this.macro;

        // Replace all variables and evaluate expressions

        let parts = [...matchRecursive(result, "[...]")];
        let expressionsTree = expandTreeExpressions(parts, this.sheet);

        result = resolveTreeExpressions(expressionsTree, result, false);

        // Parse Controllers and Functions

        result = parseControlFunctions(result);

        return result.split('\n');
    }
}